module.exports = __webpack_public_path__ + "static/img/qualification1.96152ab2.png";